import { RETRIEVABLE_STREAM_SIZE_ATTRIBUTE } from "data-lake/streams-overview-extension/streamsOverviewExtension";
export const DEFAULT_DISPLAYED_ATTRIBUTES = [
  "stream_id",
  "retrievable_stream_size",
  "message_count",
  "days_of_data",
  "timestamp_from",
  "timestamp_to",
  "restored_indices"
];
export const DEFAULT_LAYOUT = {
  entityTableId: "datalake",
  defaultPageSize: 20,
  defaultSort: { attributeId: "stream_id", direction: "asc" },
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES
};
export const ADDITIONAL_ATTRIBUTES = [
  RETRIEVABLE_STREAM_SIZE_ATTRIBUTE,
  { id: "restored_indices", title: "Restore operations", hidden: false },
  { id: "days_of_data", title: "Days of data", hidden: false }
];
